
        $(document).ready(function () {
            $('.equiptment-slider').owlCarousel({
                loop: true,
                nav: true,
                dots: true,
                autoplay: false,
                autoplayTimeout: 4000,
                autoplayHoverPause: true,
                smartSpeed: 800,

                navText: [
                    "<i class='fa-solid fa-chevron-left'></i>",
                    "<i class='fa-solid fa-chevron-right'></i>"
                ],

                responsive: {
                    0: {
                        items: 1
                    },
                    576: {
                        items: 2
                    },
                    992: {
                        items: 4
                    }
                }
            });
        });
        $(document).ready(function () {
            $('.testimonial-slider').owlCarousel({
                items: 1,
                loop: true,
                dots: false,
                nav: false,
                smartSpeed: 800
            });

            // custom arrows
            $('.testimonial-card .next').click(function () {
                $('.testimonial-slider').trigger('next.owl.carousel');
            });

            $('.testimonial-card .prev').click(function () {
                $('.testimonial-slider').trigger('prev.owl.carousel');
            });
        });

        const swiper = new Swiper('.testimonialSwiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            speed: 600,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });
